import { readJson, remove, writeJson } from "../lib/storage";
import { desktopApp } from "./desktop";
import { supportWindow } from "./support";

/**
 * The device token proves this till is paired with a shop. It is kept on this device only;
 * unpairing the device in the owner's dashboard makes it worthless at once (ADR 0007).
 * A support window of Tafo (🛟 Inloggen als zaak) uses its own token for that window only and never
 * touches the token of the till that is paired on this computer.
 */
const KEY = "tafo.deviceToken";

export const deviceToken = {
  read: (): string | null => supportWindow.read()?.token ?? readJson<string | null>(KEY, null),
  save: (token: string): void => {
    if (supportWindow.read() !== null) return;
    writeJson(KEY, token);
    // the Tafo app for Windows prints with it (blok I)
    desktopApp()?.setDeviceToken(token);
  },
  clear: (): void => {
    if (supportWindow.read() !== null || supportWindow.ended()) {
      supportWindow.end();
      return;
    }
    remove(KEY);
    desktopApp()?.setDeviceToken(null);
  },
  /** Tells the Tafo app for Windows the token this till starts with. */
  announce: (): void => {
    if (supportWindow.read() !== null) return;
    desktopApp()?.setDeviceToken(readJson<string | null>(KEY, null));
  },
};
